export default "__VITE_ASSET__CUbEd6LP__"